import "./commercial-clients.css";

export default function CommercialClients() {
  const clients = [
    {
      name: "Bunnings Trade",
      logo: "/static/images/commercial-maintenance/commercial-clients/bunnings-trade.webp",
    },
    {
      name: "Subway",
      logo: "/static/images/commercial-maintenance/commercial-clients/subway.webp",
    },
    {
      name: "Australian Professional Shopfitters",
      logo: "/static/images/commercial-maintenance/commercial-clients/australian-professional-shopfitters.webp",
    },
    {
      name: "MPower Me",
      logo: "/static/images/commercial-maintenance/commercial-clients/mpower-me.webp",
    },
    {
      name: "Simply Better Services Australia",
      logo: "/static/images/commercial-maintenance/commercial-clients/sbs-australia.webp",
    },
    {
      name: "Case Meallin Hawthorn",
      logo: "/static/images/commercial-maintenance/commercial-clients/case-meallin.webp",
    },
    {
      name: "Tyquin Industrial Services",
      logo: "/static/images/commercial-maintenance/commercial-clients/tyquin-industrial.webp",
    },
    {
      name: "Area Specialist",
      logo: "/static/images/commercial-maintenance/commercial-clients/area-specialist.webp",
    },
    {
      name: "Belle Property",
      logo: "/static/images/commercial-maintenance/commercial-clients/belle-property.webp",
    },
    {
      name: "Tyquin Industrial Services",
      logo: "/static/images/commercial-maintenance/commercial-clients/pica-group.webp",
    },
  ];

  return (
    <section className="commercial-clients-banner">
      <div className="commercial-clients-inner">

        <h2>Trusted by Melbourne Businesses</h2>

        <p className="commercial-clients-intro">
          Providing commercial maintenance and handyman
          services for businesses across Melbourne.
        </p>

        <div className="commercial-clients-grid">
          {clients.map((client) => (
            <div
              className="commercial-client-logo"
              key={client.name}
            >
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
